<template>
  <section class="short-video-area text-center short-video-area-padding">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">

                <noscript>
                    <h1>yt player requires javascript. please enable javascript and reload this page to continue</h1>
                    <br>
                </noscript>

                <div class="container">
                    <div class="child">
                        <div id="notification" class=""></div>
                        <form action="javascript:void(0);" style="margin-top: 200px;">
                            <button 
                                class="btn btn-danger short-youtube-video-play-btn my-auto mx-auto" 
                                @click="openModal" 
                                aria-label="play video" 
                                data-balloon-pos="up"
                            >
                                <i class="fa fa-play-circle fa-3x" aria-hidden="true"></i>
                            </button>
                            <!-- <div class="mt-3">
                                <h4 style="color: white; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);">Дархад</h4>
                            </div> -->
                        </form>
                    </div>
                </div>

                <!-- Video Modal -->
                <div 
                    id="overlay" 
                    v-show="showModal"
                    :style="{ display: showModal ? 'block' : 'none', cursor: 'none' }"
                    @click.self="closeModal"
                >
                    <div id="overlay-content">
                        <div id="buttons-container">
                            <button 
                                class="overlay-buttons transparent-button material-icons-round" 
                                aria-label="close" 
                                data-balloon-pos="up" 
                                @click="closeModal"
                            >
                                close
                            </button>
                            <button 
                                class="overlay-buttons transparent-button material-icons-round" 
                                aria-label="maximize" 
                                data-balloon-pos="up" 
                                @click="toggleFullscreen"
                            >
                                {{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}
                            </button>
                            <button 
                                class="overlay-buttons transparent-button material-icons-round" 
                                aria-label="minimize" 
                                data-balloon-pos="up" 
                                @click="minimizeVideo"
                            >
                                minimize
                            </button>
                        </div>

                        <div id="overlay-notification"></div>
                        <progress 
                            id="loader" 
                            aria-label="loading video..." 
                            data-balloon-pos="up" 
                            v-show="isLoading"
                        ></progress>
                        <iframe 
                            v-if="showModal"
                            ref="videoFrame"
                            allowfullscreen 
                            :src="videoUrl"
                            width="100%" 
                            height="100%"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        >
                            <p>Your browser does not support iframes.</p>
                        </iframe>
                    </div>
                </div>

                <div 
                    id="expand-box" 
                    v-show="isMinimized"
                    :class="{ 'hidden': !isMinimized }" 
                    aria-label="click to reopen video" 
                    data-balloon-pos="left"
                    @click="expandVideo"
                >
                    <img id="thumbnail" alt="video thumbnail" :src="thumbnailUrl">
                    <div id="expand-hint-text">minimized video</div>
                </div>

            </div>
        </div>
    </div>
</section>
</template>

<script>
export default {
  name: 'HomeYoutube',
  data() {
    return {
      showModal: false,
      isLoading: false,
      isFullscreen: false,
      isMinimized: false,
      videoId: 'IR3pV8vXbVs', // The YouTube video ID
      autoplay: true
    }
  },
  computed: {
    videoUrl() {
      const baseUrl = 'https://www.youtube.com/embed/';
      const params = new URLSearchParams({
        autoplay: this.autoplay ? 1 : 0,
        rel: 0, // Don't show related videos from other channels
        modestbranding: 1, // Reduce YouTube branding
        fs: 1, // Allow fullscreen
        cc_load_policy: 0, // Don't show captions by default
        iv_load_policy: 3, // Hide video annotations
        enablejsapi: 1 // Enable JavaScript API
      });
      return `${baseUrl}${this.videoId}?${params.toString()}`;
    },
    thumbnailUrl() {
      return `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`;
    }
  },
  methods: {
    openModal() {
      this.isLoading = true;
      this.showModal = true;
      this.isMinimized = false;
      
      // Hide loading after a short delay
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    },
    
    closeModal() {
      this.showModal = false;
      this.isMinimized = false;
      this.isFullscreen = false;
      
      // Restore body scroll
      document.body.style.overflow = 'auto';
    },
    
    minimizeVideo() {
      this.showModal = false;
      this.isMinimized = true;
    },
    
    expandVideo() {
      this.showModal = true;
      this.isMinimized = false;
    },
    
    toggleFullscreen() {
      if (!document.fullscreenElement) {
        this.$refs.videoFrame?.requestFullscreen?.();
        this.isFullscreen = true;
      } else {
        document.exitFullscreen?.();
        this.isFullscreen = false;
      }
    }
  },
  
  mounted() {
    // Listen for fullscreen changes
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement;
    });
    
    // Close modal on Escape key
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.showModal) {
        this.closeModal();
      }
    });
  }
}
</script>

<style scoped>
.short-video-area {
    background: rgb(251, 209, 221);
    background: linear-gradient(90deg, rgb(251, 209, 221) 0%, rgb(239, 221, 214) 31%, rgb(248, 231, 221) 67%, rgb(255, 254, 255) 100%);
    min-height: 500px;
    background-image: url('https://www.gazar.gov.mn/assets/theme01/img/background/video-background-02.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
}

#overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

#overlay-content {
    position: relative;
    width: 90%;
    height: 90%;
    max-width: 1200px;
    max-height: 675px;
}

#buttons-container {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10000;
    display: flex;
    gap: 10px;
}

.overlay-buttons {
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 18px;
    transition: background-color 0.3s;
}

.overlay-buttons:hover {
    background: rgba(0, 0, 0, 0.9);
}

#expand-box {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 200px;
    height: 112px;
    background: black;
    border: 2px solid white;
    cursor: pointer;
    z-index: 9998;
    border-radius: 8px;
    overflow: hidden;
}

#expand-box img {
    width: 100%;
    height: 80%;
    object-fit: cover;
}

#expand-hint-text {
    color: white;
    text-align: center;
    font-size: 12px;
    padding: 4px;
    background: rgba(0, 0, 0, 0.8);
}

#loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10001;
}

.short-youtube-video-play-btn {
    transition: transform 0.3s ease;
}

.short-youtube-video-play-btn:hover {
    transform: scale(1.1);
}
</style>